<template>
  <div class="d-flex flex-column refer-to-eap">
    <h2 class="dmh-start-title brand-text">
      {{ pageContent.title }}
    </h2>
    <p class="dmh-start-subheading brand-text">
      {{ pageContent.subtitle }}
    </p>
    <div v-if="isEAPRequestLoading" class="d-flex justify-content-center mb-5">
      <b-spinner class="brand-primary"></b-spinner>
    </div>
    <p v-else-if="isEAPRequestSent" class="dmh-start-subheading brand-text">
      {{ EAPRequestMessage }}
    </p>
    <div v-else class="d-flex flex-column mb-5">
      <div class="phone-input-wrapper">
        <input
          class="phone-input brand-text"
          id="phone"
          type="tel"
          v-model="phoneNumber"
          @input="formatPhoneNumber"
          placeholder="Enter your phone number"
        />
        <p v-if="phoneError" class="error-text">
          <i class="fa-exclamation-circle fas mr-3"></i>
          <span> {{ phoneError }}</span>
        </p>
      </div>
      <b-button
        @click="sendEAPRequest"
        :disabled="!validatePhoneNumber(phoneNumber)"
        variant="cta"
        size="lg"
        class="align-self-end mt-4"
        >{{ pageContent.buttonText }}</b-button
      >
    </div>
    <div class="d-flex flex-column">
      <div v-if="phoneNumbers" class="contact-numbers-wrapper">
        <div 
          v-for="(label, key) in phoneNumbers" 
          :key="key" 
          class="col-sm-12 phone-numbers-item mb-4"
        >
          <div>
            {{ key.split("_").join(" ") }}:
            <a
              :href="`tel:${label}`"
              class="phone-numbers-link brand-text ml-3"
            >
              {{ label }}
            </a>
          </div>
        </div>
      </div>
      <b-button
        variant="cta-outline"
        size="lg"
        id="return-to-home-button"
        class="align-self-end py-4 px-5"
        squared
        @click="redirectHandler()"
        >Return to 'My Health'</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import SHPhoneNumbers from "../DMH/SHPhoneNumbers.vue";
import { redirectHandler } from "@/utils/RedirectHandler";

export default {
  name: "ReferToEAP",
  components: {
    SHPhoneNumbers
  },
  props: {
    pageContent: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      isEAPRequestLoading: false,
      isEAPRequestSent: false,
      phoneNumbers: null,
      arePhoneNumbersLoading: false,
      EAPRequestMessage: "",
      phoneNumber: "",
      phoneError: "",
    };
  },
  mounted() {
    this.getPhoneNumbers()
  },
  methods: {
    redirectHandler,
    async sendEAPRequest() {
      if (this.isEAPRequestLoading) return;
      try {
        this.isEAPRequestLoading = true;
        const payload = {
          user_id: this.$store.getters.user_id,
          phone: this.phoneNumber,
          service_id: 0
        };
        const res = await axios.post(
          config.api_env + "/application/api-hc/send-eap-request",
          payload,
          config.options
        );
        this.isEAPRequestSent = true;
        if (res.data.sent) {
          this.EAPRequestMessage =
            "Thank you, please expect a callback within 24hrs.";
        } else {
          this.EAPRequestMessage =
            "Something went wrong. Please, try again later.";
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isEAPRequestLoading = false;
      }
    },
    async getPhoneNumbers() {
      if (this.arePhoneNumbersLoading) return;
      try {
        this.arePhoneNumbersLoading = true;
        const payload = {
          user_id: this.$store.getters.user_id,
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/dmh/get-phone-numbers",
          payload,
          config.options
        );
        if (res.status === 200) {
          this.phoneNumbers = res.data
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.arePhoneNumbersLoading = false;
      }
    },
    formatPhoneNumber() {
      const isCorrect = this.validatePhoneNumber(this.phoneNumber);
      if (isCorrect) {
        this.phoneError = "";
      } else {
        this.phoneError = "Must be a valid phone number with at least 8 digits";
      }
    }
  }
};
</script>

<style lang="less">
.refer-to-eap {
  .phone-input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 20px;
  }

  .phone-numbers-item {
    font-size: 1.8rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .phone-numbers-link {
    font-family: "PlusJakartaSansBold";
  }

  .phone-input {
    width: 100%;
    border: 1px solid #aeb0bd;
    border-radius: 12px;
    background-color: #fff;
    padding: 16px;
    font-size: 1.6rem;
    line-height: 2.2rem;

    &:focus {
      outline-width: 0px;
      border: 1px solid #1e1e22;
    }
  }

  .contact-numbers-wrapper {
    border: 1px solid #e0e5f5;
    padding: 20px;
    border-radius: 16px;
    margin-bottom: 28px;
  }

  .error-text {
    border-radius: 8px;
    border: 1px solid #f40b0b;
    color: #f40b0b !important;
    background-color: #eababa;
    padding: 10px;
    margin-top: 10px;
    font-size: 1.6rem;
  }
}
</style>
